let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8ywnJ")).then(() => parcelRequire('8Idfs'));